import moment from 'moment';

function calculateAge(date) {
  return moment().diff(date, 'years');
}

function setAge(d) {
  var b = moment(d);
  var a = new Date();

  a = moment(a);

  var years = a.diff(b, 'year');
  b.add(years, 'years');

  var months = a.diff(b, 'months');
  b.add(months, 'months');

  var days = a.diff(b, 'days');
  var age = {
    y: years,
    m: months,
    d: days
  }
  return age
}

function setAgeFromVisit(d, i) {
  var b = moment(d);
  var a = moment(i);

  a = moment(a);

  var years = a.diff(b, 'year');
  b.add(years, 'years');

  var months = a.diff(b, 'months');
  b.add(months, 'months');

  var days = a.diff(b, 'days');
  var age = {
    y: years,
    m: months,
    d: days
  }
  return age
}
function getBase64(file) {

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  });
}
export { calculateAge, setAge, setAgeFromVisit, getBase64 };
